export const subtitles = {
    "1": {
        "startTime": 6.17,
        "endTime": 6.9,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "2": {
        "startTime": 6.91,
        "endTime": 13.47,
        "transcript": "Au͡gkut ava-i waten qalarutkellrenka amllertaluki.",
        "translation": "This is will be all for what I've just spoken about."
    },
    "3": {
        "startTime": 13.475,
        "endTime": 24.135,
        "transcript": "Tau͡gaam cali nutaan uum tememta-w' tua-i anirtuumangnaqlerkaanek maani nunam qaingani",
        "translation": "But also, in order to try to keep our bodies safe here on this earth"
    },
    "4": {
        "startTime": 25.71,
        "endTime": 31.74,
        "transcript": "Yaa, picurlanritlerkaanek cali qanqatartua.",
        "translation": "Yes, I'm also going to speak on how it wouldn't get into misfortune."
    },
    "5": {
        "startTime": 31.88,
        "endTime": 35.04,
        "transcript": "Waniwa mat'um nalliini",
        "translation": "Now, these days."
    },
    "6": {
        "startTime": 37.395,
        "endTime": 45.735,
        "transcript": "Uksumi ukut waniwa ellalliurcuutet: qerrulliik, ellalliurcuun",
        "translation": "These rainproof clothese in the winter: rainpants, raincoat"
    },
    "7": {
        "startTime": 46.2,
        "endTime": 55.06,
        "transcript": "Taukut tua-i uksumi waten cataicunailnguut ayagaluni.",
        "translation": "Those should not be absent in the winter like this when traveling."
    },
    "8": {
        "startTime": 59.765,
        "endTime": 66.635,
        "transcript": "Tua-i uum temem waniw' assirluni",
        "translation": "For this body to be good"
    },
    "9": {
        "startTime": 68.385,
        "endTime": 80.845,
        "transcript": "Tuaggun cali maani nunam qaingani pekeskumta yuilqumi ukut tua-i waniw' ellalliurcuutet cataicunailnguut.",
        "translation": "Also through that, if we walk on this land, in the wilderness, these rainproof clothes shouldn't be absent."
    },
    "10": {
        "startTime": 80.97,
        "endTime": 86.89,
        "transcript": "Uum temem assirluni pillerkaa.",
        "translation": "It's so that this body will be good."
    },
    "11": {
        "startTime": 87.795,
        "endTime": 98.515,
        "transcript": "Tua-i-llu pitsaqevkenani cali ellalliurcuutaunani yuilqumi arenqiallugeskuni",
        "translation": "Then, should a person get into misfortune in the wilderness without rain gear"
    },
    "12": {
        "startTime": 100.19,
        "endTime": 107.8,
        "transcript": "Ellaqerruskani tua-i wangkuta alerqutullruitkut",
        "translation": "If the weather turns bad on them, they used to instruct us"
    },
    "13": {
        "startTime": 108.65,
        "endTime": 119.77,
        "transcript": "Ayuquciiruskumta-gguq, ayuquciireskumta ayagiinarpek'nata arulaiqilta.",
        "translation": "They said that if we get lost, we shouldn't keep going but stop."
    },
    "14": {
        "startTime": 120.865,
        "endTime": 131.865,
        "transcript": "Wall'u pirtunguskakut nutaan-gguq waten tua-i nangrramta pikumta",
        "translation": "Or if a blizzard hits us, they said that especially if we [have nothing but] what we're standing in like this"
    },
    "15": {
        "startTime": 133.46,
        "endTime": 144.79,
        "transcript": "Camek-wa tua-i piinata ayagakumta, aklumek kangcirarrarmek-llu piinata",
        "translation": "If we travel without anything, and if we don't have the supply tarpaulin"
    },
    "16": {
        "startTime": 145.0,
        "endTime": 147.97,
        "transcript": "Waten alerqutullruitkut:",
        "translation": "They used to instruct us like this:"
    },
    "17": {
        "startTime": 148.01,
        "endTime": 159.02,
        "transcript": "Tua-i-gguq arenqiallugeskumta pirtunguskakut waten qanikcaq elagluku.",
        "translation": "They said if we come to misfortune, if a blizzard his us, to dig into the snow like this."
    },
    "18": {
        "startTime": 163.34,
        "endTime": 170.1,
        "transcript": "Tua-i itqilta camek tau͡gaam cali tegumiarrarluteng.",
        "translation": "We should go in, but they'd also hold something small."
    },
    "19": {
        "startTime": 170.105,
        "endTime": 177.045,
        "transcript": "Una-gguq waniw' ayaruq uum temem cali anirtuumatkaqaa.",
        "translation": "They said this walking staff would be salvation for this body."
    },
    "20": {
        "startTime": 177.06,
        "endTime": 186.99,
        "transcript": "Wall'u uksumi ayaruilkuni ca-w' tua-i naparraq tegumiaqluku ayagakuni",
        "translation": "Or, if [s]he has no staff in the winter, it [s]he holds on to a branch while going"
    },
    "21": {
        "startTime": 187.14,
        "endTime": 196.72,
        "transcript": "Tua-i-llu pirtunguskani, ayuquciiruskuni elaulluni qanikcautelluni.",
        "translation": "Then when a blizzard hits and [s]he is lost, [s]he should dig and have the snow cover them."
    },
    "22": {
        "startTime": 196.725,
        "endTime": 205.875,
        "transcript": "Tau͡gaam cali imkunun, kanarviknernek iciw' aptukput ilutulriit.",
        "translation": "But also, to those things, you know how we refer to those deep [hollows/depressions] as kanarvikneret."
    },
    "23": {
        "startTime": 205.885,
        "endTime": 212.155,
        "transcript": "Pirciqan pagna qertuluni, tua-i-llu una ilutuluni",
        "translation": "If there's a blizzard, and [the summit] up there is high, and this [depression] is deep"
    },
    "24": {
        "startTime": 212.165,
        "endTime": 218.255,
        "transcript": "Tamaavet-gguq qanikcaucetenrilkilta.",
        "translation": "They said we shouldn't have the snow cover us there."
    },
    "25": {
        "startTime": 218.265,
        "endTime": 226.935,
        "transcript": "Imumun-gguq tau͡gaam waten qerkilngurmun elagluku tauna.",
        "translation": "Instead, they said that we should dig into a low hill"
    },
    "26": {
        "startTime": 227.335,
        "endTime": 239.495,
        "transcript": "Itqumta tuavet tua-i engelqayaguskumta una imna itlerput patuqerluku qanikcarmek.",
        "translation": "When we go in when we fit in there, we should close our entrance with snow."
    },
    "27": {
        "startTime": 239.51,
        "endTime": 243.8,
        "transcript": "Tau͡gaam-gguq engelqiutevkenata.",
        "translation": "But, they said not to get it too small."
    },
    "28": {
        "startTime": 243.81,
        "endTime": 252.61,
        "transcript": "Waten elliuraqluku qanikcaq, una-llu naparrluku pagaavet ukilluku pikna.",
        "translation": "Do this to the snow, and set this [staff] upright to pierce [the ceiling] up there."
    },
    "29": {
        "startTime": 254.125,
        "endTime": 262.395,
        "transcript": "Tua-i qanikcauskakut pikna tau͡gaam waten elliuqaqluku.",
        "translation": "If we get covered in snow, do this [to open it] up there."
    },
    "30": {
        "startTime": 263.065,
        "endTime": 269.975,
        "transcript": "Umcikuni-gguq qanikaam aciani epciquq yuk.",
        "translation": "They said if a person is airtight under snow, [s]he will suffocate."
    },
    "31": {
        "startTime": 270.595,
        "endTime": 276.155,
        "transcript": "Ataucirqumek epsarpiallruukut pavani.",
        "translation": "Once, we almost suffocated inland."
    },
    "32": {
        "startTime": 277.85,
        "endTime": 284.64,
        "transcript": "Pingayuuluta: kinguqliqa, au͡gna-llu Kuigglugmiungurtelleq, wiinga-llu.",
        "translation": "There were three of us: my younger sibling, and that one who moved to Kwethluk, and me."
    },
    "33": {
        "startTime": 288.54,
        "endTime": 294.83,
        "transcript": "Waten ilutuuralriami pelatekarluta pillemteńi",
        "translation": "When we set up a tent in a deep [depression]"
    },
    "34": {
        "startTime": 297.3,
        "endTime": 305.57,
        "transcript": "Unugmi pirtunglliniluni waten anuqlirluku pillemteńi. Ellaqertelliniluni.",
        "translation": "A blizzard started at night when we [set up] when it was windy like this. The weather turned bad."
    },
    "35": {
        "startTime": 305.58,
        "endTime": 313.36,
        "transcript": "Uiga'rtua epsalngupiarlua. Mak'arcaaqellrianga puukarluku man'a.",
        "translation": "I opened my eyes and felt very suffocated. I quickly got up and hit this [ceiling]."
    },
    "36": {
        "startTime": 313.365,
        "endTime": 319.065,
        "transcript": "Cunaw' tua-i waten engillinikii qanikcaam.",
        "translation": "Apparently, the snow was weighing down on it like this."
    },
    "37": {
        "startTime": 319.22,
        "endTime": 325.09,
        "transcript": "Pegnem tuani anellruukut, akluput-llu mecungluteng.",
        "translation": "We got out after much struggle then, and our things were wet."
    },
    "38": {
        "startTime": 325.1,
        "endTime": 330.17,
        "transcript": "Amta-ll' ella qakemna nengelvagluni.",
        "translation": "And yet, the weather out there was very cold."
    },
    "39": {
        "startTime": 330.39,
        "endTime": 337.51,
        "transcript": "Qanikcaam acia waten umcigluni kiirtulliniuq epsalngunaqluni.",
        "translation": "When it's airtight under the snow like this, it's evidently very hot and hard to breathe."
    },
    "40": {
        "startTime": 338.175,
        "endTime": 346.955,
        "transcript": "Qanikcaq tua-i waten urugturluku akpulut qaingit mecunglluteng inarrviput.",
        "translation": "The snow kept melting like this and made our things, our beds, wet."
    },
    "41": {
        "startTime": 349.08,
        "endTime": 355.44,
        "transcript": "Taumek tamana waten inerqutullruitkut:",
        "translation": "That's why they would admonish us like this:"
    },
    "42": {
        "startTime": 355.785,
        "endTime": 364.705,
        "transcript": "Ellaqerruskakut tuaten tua-i ilutulrianun uqitesqevkenata, qanikcautesqevkenata.",
        "translation": "If the weather turns bad in us, we shouldn't shelter in deep [depressions], shouldn't let the snow cover us."
    },
    "43": {
        "startTime": 364.72,
        "endTime": 372.54,
        "transcript": "Tau͡gaam qerkilngurmun wall' qanikcangraan mamkitarkamun.",
        "translation": "Instead, [shelter] on a low hill or where it will be thin despite snowing."
    },
    "44": {
        "startTime": 373.255,
        "endTime": 380.065,
        "transcript": "Waten cali ukiarrluku pikna, tuaten tua-i arula'artaqluku.",
        "translation": "Also, pierce [the ceiling] up there like this, and even move it back and forth."
    },
    "45": {
        "startTime": 382.115,
        "endTime": 390.075,
        "transcript": "Tuamtellu cali waten nallunrilkumteggu kingunerput tekitarkaunrilkumta",
        "translation": "Then, if we also know that we're not going to make it back home"
    },
    "46": {
        "startTime": 390.32,
        "endTime": 399.43,
        "transcript": "Camek-gguq kapuarciluta nunam taum ciunemta tungiinun itqilta.",
        "translation": "They said we should stick soemthing in the land toward our destination and go in."
    },
    "47": {
        "startTime": 399.97,
        "endTime": 408.22,
        "transcript": "Tua-i-gguq assirluni eruskakut",
        "translation": "They said that if dawn comes with good weather"
    },
    "48": {
        "startTime": 408.23,
        "endTime": 416.51,
        "transcript": "Imna tua-i tauna nalluvkenaku ayuquciitevkenaku ciunerput amna ullagarkauluku.",
        "translation": "We will know and not be confused, and will go to our destination over there."
    },
    "49": {
        "startTime": 416.945,
        "endTime": 422.095,
        "transcript": "Tang tua-i man'a",
        "translation": "This, you see"
    },
    "50": {
        "startTime": 423.455,
        "endTime": 436.255,
        "transcript": "Au͡gna-w' tua-i elpekqallerput apertuarassiyaagumanriami-w' tua-i, wangkuta-llu apertuanriamteggu",
        "translation": "Since noticing things is not demonstrated too much anymore, and since we don't demonstrate it anymore"
    },
    "51": {
        "startTime": 436.83,
        "endTime": 439.85,
        "transcript": "Waten nallungekput.",
        "translation": "We're starting not to know it like this."
    },
    "52": {
        "startTime": 439.855,
        "endTime": 444.595,
        "transcript": "Cauciirulluta mat'um nalliini.",
        "translation": "We are ignorant these days."
    },
    "53": {
        "startTime": 444.61,
        "endTime": 448.73,
        "transcript": "Ava-i au͡gna waten amlleriuq.",
        "translation": "That's all for that [subject]."
    },
    "54": {
        "startTime": 448.735,
        "endTime": 453.215,
        "transcript": "Tua-llu cali umyuaqelalqa",
        "translation": "Then, what's also been on my mind"
    },
    "55": {
        "startTime": 453.23,
        "endTime": 464.62,
        "transcript": "Au͡gkut makut anglicartellemta ilaput nalluvkanritellruit",
        "translation": "Those who raised us back then didn't keep us from knowing our relatives"
    },
    "56": {
        "startTime": 464.63,
        "endTime": 469.02,
        "transcript": "Nani nunani allani uitangraata.",
        "translation": "Even if they're in other villages somewhere."
    },
    "57": {
        "startTime": 469.03,
        "endTime": 479.98,
        "transcript": "Iciw' maa-i ilu'uqniluki, angakniluki, anaanakniluki, nuliacungaqniluki",
        "translation": "You know, these days, they're told those people are their [male to male] cross-cousins, maternal uncles, maternal aunts, [male to female] cross-cousins"
    },
    "58": {
        "startTime": 479.99,
        "endTime": 483.35,
        "transcript": "Tamakut apertuamalaryaaqut.",
        "translation": "Those do get pointed out."
    },
    "59": {
        "startTime": 484.855,
        "endTime": 495.545,
        "transcript": "Maa-i mat'um nalliini waten cakuciirulluta pilriakut.",
        "translation": "These days, we don't know anything like this."
    },
    "60": {
        "startTime": 495.855,
        "endTime": 508.535,
        "transcript": "Waten avani wangkuta waten tan'gaurlullraullemteńi apertuatetullruitkut au͡gkut anglicartemta.",
        "translation": "Back when we were little boys like this, those who raised us back then would teach us."
    },
    "61": {
        "startTime": 508.55,
        "endTime": 519.35,
        "transcript": "Waten-llu nunanek tekitaqameng, ukut ilakellriit tekitaqameng",
        "translation": "And when they arrived from [other] villages like this, when these relatives arrived"
    },
    "62": {
        "startTime": 519.355,
        "endTime": 522.715,
        "transcript": "Apertuatnauraitkut.",
        "translation": "They would point out to us."
    },
    "63": {
        "startTime": 524.82,
        "endTime": 530.27,
        "transcript": "Wangkuta-gguq tauna-llu cakukut.",
        "translation": "They said we and that person are related somehow."
    },
    "64": {
        "startTime": 530.28,
        "endTime": 537.42,
        "transcript": "Ilu'urqukut, wall' usrukukut, tuaten tua-i.",
        "translation": "We're [male to male] cross cousins, or we're [male to female] niece/nephew, like that."
    },
    "65": {
        "startTime": 537.425,
        "endTime": 545.925,
        "transcript": "Tamaaggun waten nalluyuqenriqertaqluki apertuamataqameng.",
        "translation": "Through that, we'd suddenly figure out [how we're related] when they're pointed out."
    },
    "66": {
        "startTime": 547.59,
        "endTime": 555.32,
        "transcript": "Tau͡gken mat'um nalliini tuaten cakuciirulluta.",
        "translation": "These days, however, we don't know how we're related like that."
    },
    "67": {
        "startTime": 560.18,
        "endTime": 567.87,
        "transcript": "Maaggun-llu cakuciirutlemteggun, apertuacimanritlemteggun",
        "translation": "And through this, not knowing how we're related, how we're not shown [how we're related]"
    },
    "68": {
        "startTime": 567.96,
        "endTime": 573.74,
        "transcript": "Mat'um nalliini nakukutengluteng yuut.",
        "translation": "These days, people are starting to fight each other."
    },
    "69": {
        "startTime": 573.745,
        "endTime": 586.545,
        "transcript": "Amta-ll' waten ilakutaqluteng-llu ping'e'rmeng nallukulluteng. Inglukutengluteng mat'um nalliini.",
        "translation": "And yet, though they're related like this, they' fight. They've started fighting these days."
    },
    "70": {
        "startTime": 586.56,
        "endTime": 591.82,
        "transcript": "Au͡gkut avani nepaitellruut yuut.",
        "translation": "People back then were peaceful."
    },
    "71": {
        "startTime": 592.765,
        "endTime": 599.035,
        "transcript": "Tua-i nakukutellriartaunani.",
        "translation": "There was no one fighting each other."
    },
    "72": {
        "startTime": 600.675,
        "endTime": 606.665,
        "transcript": "Au͡gna ava-i waten qanengssaka pitauq.",
        "translation": "That's the extent of my story of that."
    },
    "73": {
        "startTime": 607.995,
        "endTime": 619.355,
        "transcript": "Mat'um nalliini maa-i waten, yaa, ayuqsugnairutukut au͡gkucicetun ciuliamcecicetun.",
        "translation": "These days, like this, yes, we're no longer like our ancestors of old."
    },
    "74": {
        "startTime": 619.83,
        "endTime": 630.73,
        "transcript": "Man'a waten assiriyaaquq. Assiriyaaqukut. Assirinilaryaaqekaitkut mat'um nalliini.",
        "translation": "Now, it's gotten better like this. We've gotten better. They said we've gotten better these days."
    },
    "75": {
        "startTime": 630.735,
        "endTime": 638.815,
        "transcript": "Tau͡gaam assirinritukut. Wangkuta assirinritukut.",
        "translation": "But we haven't gotten better. We haven't gotten better."
    },
    "76": {
        "startTime": 638.825,
        "endTime": 643.135,
        "transcript": "Au͡gkut ilakulluteng pillruut.",
        "translation": "People back then were tight-knit."
    },
    "77": {
        "startTime": 643.565,
        "endTime": 647.295,
        "transcript": "Assiriyaaqukut nangteqenrirluta",
        "translation": "We have gotten better without struggling for:"
    },
    "78": {
        "startTime": 647.305,
        "endTime": 660.715,
        "transcript": "Kass'at makut aklirtungluta aturamteggun, ayagassuutemteggun, catgun tua-i, neqkamteggun, makutgun-llu enetgun",
        "translation": "These Caucasians have provided us with our clothes, our vehicles, various things, our food, and our buildings"
    },
    "79": {
        "startTime": 661.175,
        "endTime": 670.565,
        "transcript": "Nangteqenrirluta, nengelvagnanrirluteng unugmi, kiirpiurturangluta.",
        "translation": "We stopped suffering, stopped being afflicted with great cold at night, started being hot all the time."
    },
    "80": {
        "startTime": 671.945,
        "endTime": 675.345,
        "transcript": "Assiriyaaqluni.",
        "translation": "It had gotten better."
    },
    "81": {
        "startTime": 675.36,
        "endTime": 682.24,
        "transcript": "Tau͡gaam assiirulluteng, assiirulluta mat'um nalliini.",
        "translation": "But they've gotten worse, we've gotten worse these days."
    },
    "82": {
        "startTime": 682.245,
        "endTime": 686.715,
        "transcript": "Nakukutengluteng. Tuqurqutengluteng.",
        "translation": "They've started fighting each other. They've started killing each other."
    },
    "83": {
        "startTime": 689.585,
        "endTime": 697.035,
        "transcript": "Qaneryaram mat'um apertullra natruartevkenaku.",
        "translation": "It went exactly as this Bible said it would."
    },
    "84": {
        "startTime": 698.855,
        "endTime": 711.515,
        "transcript": "Kitak' waten tua-i niicugnilriani tan'gaurlurni, nasaurlurni umyuaqelarniarci au͡gna niitellerci.",
        "translation": "Now, you boys and girls who are listening like this, remember what you just heard."
    },
    "85": {
        "startTime": 711.53,
        "endTime": 716.79,
        "transcript": "Au͡gkut anglicarteput waten ayuqellrunritut.",
        "translation": "Those who raised us back then weren't like this."
    },
    "86": {
        "startTime": 717.715,
        "endTime": 728.915,
        "transcript": "Aturanek amllernek enem iluani pitangqellrunrituq enait waten ayuqellrunrilameng.",
        "translation": "There weren't a lot of accouterments in a home because their homes weren't like this."
    },
    "87": {
        "startTime": 729.67,
        "endTime": 742.81,
        "transcript": "Unugmi-lli qava'arqameng nengelvagmi qaltat tua-i makut mernek imalget cikumaluteng, cikuaqluki.",
        "translation": "And when they slept at night in the extreme cold, these buckets filled with water would freeze."
    },
    "88": {
        "startTime": 742.815,
        "endTime": 751.895,
        "transcript": "Kaminiam-llu qainganlengraata, imkut saaniiget puqlanillrung'e'rmeng ilait tua-i cikumaaqluteng",
        "translation": "And even if they were on the stove, even though those kettles had been warm, some would [end up] frozen."
    },
    "89": {
        "startTime": 752.69,
        "endTime": 756.34,
        "transcript": "Ii-i, tua-i waten... (Qaillun-mi...)",
        "translation": "Yes, this [is it]... (So, how...)"
    },
    "90": {
        "startTime": 763.69,
        "endTime": 767.5,
        "transcript": "Kitak' apyuten, apesnga.",
        "translation": "Now, your question, ask me."
    },
    "91": {
        "startTime": 768.83,
        "endTime": 773.83,
        "transcript": "Qaillun iciw' auluklerkait angutet, arnat.",
        "translation": "You know, how to take care of men, women."
    },
    "92": {
        "startTime": 773.835,
        "endTime": 782.645,
        "transcript": "Iciw' angutet qanruyutait arnanun, iciw' qaillun angutet iciw' qanruyutait qaillun kassuusngalriit iciw' auluklerkait aipateng.",
        "translation": "You know, men's traditional wisdom about owmen, you know, how men, you know, their traditional wisdom, how married couples, you know, take care of their spouses."
    },
    "93": {
        "startTime": 782.655,
        "endTime": 784.085,
        "transcript": "Ii-i.",
        "translation": "Okay."
    },
    "94": {
        "startTime": 785.135,
        "endTime": 792.805,
        "transcript": "Waten maa-i kassuusngalriit, ukuk kassuutellriik",
        "translation": "Now, married couples like this, this married couple"
    },
    "95": {
        "startTime": 794.265,
        "endTime": 801.975,
        "transcript": "Agayulirtem tuaten aptelarak.",
        "translation": "The priest asks them a question like that."
    },
    "96": {
        "startTime": 801.985,
        "endTime": 810.295,
        "transcript": "Agayutem ciuqerrani aptelarak waten:",
        "translation": "In front of God, [s]he asks them this:"
    },
    "97": {
        "startTime": 810.855,
        "endTime": 820.745,
        "transcript": "\"Tua-i-qaa aipaqutarkaugutek qigcikullutek, maligtaqullutek, uivnun maligtaqulluten?",
        "translation": "\"In your marriage, will you respect each other, obey each other, obey your husband?"
    },
    "98": {
        "startTime": 820.865,
        "endTime": 827.815,
        "transcript": "\"Wall'u uingulriami nulirpenun maligtaqulluten.\"",
        "translation": "\"Or, you who is a husband, obey your wife.\""
    },
    "99": {
        "startTime": 827.865,
        "endTime": 832.545,
        "transcript": "Tuaten waten pimalaryaaquq tamana",
        "translation": "That's how this is done"
    },
    "100": {
        "startTime": 832.56,
        "endTime": 838.67,
        "transcript": "Tau͡gaam waten alerquumaluta:",
        "translation": "But we're instructed like this:"
    },
    "101": {
        "startTime": 838.68,
        "endTime": 850.12,
        "transcript": "Tua-i-gguq ukuk waten nulirqellriik waten kassuusngalutek pikunek tua-i assirlutek piyukunek",
        "translation": "They said this married couple, if they're married like this and want to do well"
    },
    "102": {
        "startTime": 850.125,
        "endTime": 855.495,
        "transcript": "Waten maligtaquuraullutek narurtaagutevkenatek.",
        "translation": "They must obey each other like this, not disobey each other."
    },
    "103": {
        "startTime": 856.945,
        "endTime": 864.565,
        "transcript": "Uini tua-i una murilkelluku anrutaa aklui-llu, makut-ll' aklui.",
        "translation": "[S]he must watch their husband, his stomach and his possessions, and his clothes."
    },
    "104": {
        "startTime": 865.03,
        "endTime": 869.73,
        "transcript": "Makut-llu cali unangkengai murilkelluki.",
        "translation": "And [s]he must watch over [the animals] he catches."
    },
    "105": {
        "startTime": 870.755,
        "endTime": 880.105,
        "transcript": "Tuamtellu cali uingulriim cali una nuliani aulukaani",
        "translation": "Then a husband also with his wife whom he takes care of"
    },
    "106": {
        "startTime": 880.685,
        "endTime": 892.545,
        "transcript": "Enem ilua man'a arnam aulukaa, enem iluanelnguut angutem unangkengaa.",
        "translation": "A woman takes care of the inside of a home, the things in the home that the man caught."
    },
    "107": {
        "startTime": 893.19,
        "endTime": 906.7,
        "transcript": "Tau͡gken cali uingulriim cali qagna ella enem elatii",
        "translation": "However, a husband also [works] out there, outside the house"
    },
    "108": {
        "startTime": 907.06,
        "endTime": 911.56,
        "transcript": "Wall'u yuil[qumi], tamaa-i tamana caliarkaa.",
        "translation": "Or [in] the wilderness, that's his responsibility."
    },
    "109": {
        "startTime": 911.57,
        "endTime": 917.71,
        "transcript": "Nuliaminun aulukutekai cali murilkelluki.",
        "translation": "He must also watch over what he needs to take care of for his wife."
    },
    "110": {
        "startTime": 918.49,
        "endTime": 924.87,
        "transcript": "Mer'et maa-i makut enem iluani aulukutnguut arnamun.",
        "translation": "Water inside the house is a way to take care of a woman."
    },
    "111": {
        "startTime": 926.03,
        "endTime": 937.45,
        "transcript": "Tua-i-llu cali tamana pingraan waten, waten-wa tua-i maligtaquuraullutek inglukutaagutevkenatek.",
        "translation": "Then even if it's like that, they must obey each other without being at odds with each other."
    },
    "112": {
        "startTime": 939.97,
        "endTime": 948.74,
        "transcript": "Waten inerquumauk assirlutek piyukunek:",
        "translation": "They're admonished like this if they want to do well:"
    },
    "113": {
        "startTime": 948.94,
        "endTime": 953.97,
        "transcript": "Kenkuterrlainayuitut aipaqutellriit.",
        "translation": "Couples don't always treat each other with love."
    },
    "114": {
        "startTime": 954.48,
        "endTime": 956.64,
        "transcript": "Waten tau͡gaam...",
        "translation": "But like this..."
    },
    "115": {
        "startTime": 962.12,
        "endTime": 965.07,
        "transcript": "Qaillun ima tanem pilaqait?",
        "translation": "What do they tell them again?"
    },
    "116": {
        "startTime": 965.87,
        "endTime": 971.42,
        "transcript": "Inglukutaagutevkenatek-wa tua-i pillerkaak.",
        "translation": "They shouldn't be at odds with each other."
    },
    "117": {
        "startTime": 971.79,
        "endTime": 981.82,
        "transcript": "Aipaan camek-wa tua-i qanruskani umyugaan pekyutkaanek",
        "translation": "If one's spouse tells them something to make them upset"
    },
    "118": {
        "startTime": 983.9,
        "endTime": 990.27,
        "transcript": "Uingulria-gguq tauna tuaten nulirran qanrutengraani",
        "translation": "They said that for a husband, even if his wife says something to him like that"
    },
    "119": {
        "startTime": 990.28,
        "endTime": 997.87,
        "transcript": "Imna umyuami-w' tua-i navgutkengraaku ayuqelivkenaku pikuni",
        "translation": "Even if it destroys his mindset, if he doesn't do the same"
    },
    "120": {
        "startTime": 997.88,
        "endTime": 1004.21,
        "transcript": "Tua-i nulirra tauna ingluilkuni camek taqciquq.",
        "translation": "If his wife has no opposition, she will stop things."
    },
    "121": {
        "startTime": 1004.22,
        "endTime": 1010.41,
        "transcript": "Tuamtellu cali angutiin arnaq cali",
        "translation": "Then [if] the man [does the same] to the woman"
    },
    "122": {
        "startTime": 1014.75,
        "endTime": 1020.67,
        "transcript": "Umyuani-w' tua-i kenkevkenaku wall' ayuqucianek pikuni",
        "translation": "If he's not in a loving mindset or talks about her behavior"
    },
    "123": {
        "startTime": 1020.68,
        "endTime": 1029.96,
        "transcript": "Tauna-gguq taringecurlagpek'nani cali arnaq tuaten pikili, inglulitevkenani.",
        "translation": "They said the woman shouldn't misunderstand like that, and not make herself an opponent."
    },
    "124": {
        "startTime": 1029.97,
        "endTime": 1035.29,
        "transcript": "Ingluliurulluteng cat quyungqasciigatut.",
        "translation": "People in any relationship who are at odds cannoy stay together."
    },
    "125": {
        "startTime": 1035.88,
        "endTime": 1047.09,
        "transcript": "Wall'u anelgutkellriit inglukeg[sigg]luteng ayuqevkenateng pikuneng quyungqasciigatut.",
        "translation": "Or if siblings do not interact with each other well, they cannot stay together."
    },
    "126": {
        "startTime": 1048.21,
        "endTime": 1062.832,
        "transcript": "Tua-i-llu ukuk nulirqellriik tuaten tua-i ayuqekunek inglukuugullutek pikunek assirlutek pingaituk.",
        "translation": "Then if this married couple is like that, if they are at odds with other, they won't do well."
    },
    "127": {
        "startTime": 1064.7,
        "endTime": 1070.5,
        "transcript": "Nutaan-llu mikelngurmek alairikunek",
        "translation": "And especially when they bring forth a child"
    },
    "128": {
        "startTime": 1070.51,
        "endTime": 1077.42,
        "transcript": "Tua-i-gguq taum nutaan inerquutqapiarqellruyaaqaput tamana.",
        "translation": "They said with that, that was something we were especially strongly admonished with."
    },
    "129": {
        "startTime": 1077.9,
        "endTime": 1084.54,
        "transcript": "Umyuarput assiitaarluku wangkutnun pisqevkenata mikelngungkumta.",
        "translation": "They told us not to have them come to us when we upset if we have children."
    },
    "130": {
        "startTime": 1086.09,
        "endTime": 1093.13,
        "transcript": "Mikelnguut-gguq makut waten nallutaitut.",
        "translation": "They said that these children are not ignorant like this."
    },
    "131": {
        "startTime": 1094.17,
        "endTime": 1100.49,
        "transcript": "Au͡gkut waten ayuqellrunritut-llu tangvallrenka.",
        "translation": "And the ones I watched back then weren't like this."
    },
    "132": {
        "startTime": 1104.64,
        "endTime": 1115.04,
        "transcript": "Iciw' tua-i imkuvkenateng, takumteńi camek umyuarteng kiutaagucuunateng.",
        "translation": "You know, they didn't, you know, they wouldn't argue about their thoughts in our presence."
    },
    "133": {
        "startTime": 1115.05,
        "endTime": 1119.67,
        "transcript": "Tau͡gken mat'um na[lliini] qaill' maa-i ellirtat?",
        "translation": "These days, however, what did they become?"
    },
    "134": {
        "startTime": 1120.3,
        "endTime": 1132.38,
        "transcript": "Tua-i yugyangraan-llu ukuk nulirqellriik piyukunek assiilngurmek eqtaagullutek qan'ataagutarkaulutek.",
        "translation": "And even if there's a lot of people, if this married couple wants to speak badly, they will angrily argue."
    },
    "135": {
        "startTime": 1134.5,
        "endTime": 1142.38,
        "transcript": "Maa-i mat'um nalliini navguutngussiyaalria nallunritarput.",
        "translation": "These days, we know what causes too much destruction."
    },
    "136": {
        "startTime": 1142.68,
        "endTime": 1155.37,
        "transcript": "Una waniw' mat'um nalliini atuqengaat man'a, man'a, man'a-w' tua-i taangaq nulirqellriik navguuteksiyaagaak.",
        "translation": "This, what they're abusing these days, alcohol is what destroys a married couple."
    },
    "137": {
        "startTime": 1156.24,
        "endTime": 1167.65,
        "transcript": "Yugyang'e'rmeng-llu amlleng'e'rmeng tamatumek atungaqameng tua-i avvutaqluteng.",
        "translation": "And even if there's a lot of people, when they start abusing that, they divorce."
    },
    "138": {
        "startTime": 1167.66,
        "endTime": 1170.36,
        "transcript": "Navguutqapiarauluni.",
        "translation": "It's a source of great destruction."
    },
    "139": {
        "startTime": 1170.49,
        "endTime": 1181.26,
        "transcript": "Amta-ll' makut qanrutestemta makut-llu aipaimta caliaqsaaqluku.",
        "translation": "And yet, our instructors here and our [Caucasian] counterparts are working on it."
    },
    "140": {
        "startTime": 1182.21,
        "endTime": 1188.5,
        "transcript": "Ellaita pikngamegteggu tau͡gaam tua-i caliaqsaaqluku.",
        "translation": "Since it's what they [brought], they're working on it."
    },
    "141": {
        "startTime": 1189.61,
        "endTime": 1198.43,
        "transcript": "Nangyutkaat mat'um nalliini man'a, man'a-w' tua-i taangaq.",
        "translation": "These days, this alcohol torments them."
    },
    "142": {
        "startTime": 1201.15,
        "endTime": 1209.93,
        "transcript": "Au͡gkut avani waten, waten pillrunritut ava-i qanengssakekenka.",
        "translation": "People back then didn't do this, the ones I just talked about."
    },
    "143": {
        "startTime": 1210.83,
        "endTime": 1221.72,
        "transcript": "Nuliameggnek tuquciyuunateng. Irniameggnek yagirayuunateng.",
        "translation": "They never killed their wives. They never raised their hands against their children."
    },
    "144": {
        "startTime": 1224.22,
        "endTime": 1231.34,
        "transcript": "Mat'um nalliini tua-i navguutqapiarauluni nulirqellrianun.",
        "translation": "These days, it's the cause of destruction for married couples."
    },
    "145": {
        "startTime": 1231.84,
        "endTime": 1240.65,
        "transcript": "Ava-i apeskevnga qaillun nulirqellriik ayuqerkauciagnek.",
        "translation": "You just asked me what a married couple must be like."
    },
    "146": {
        "startTime": 1240.85,
        "endTime": 1248.52,
        "transcript": "Assirlutek yuugarkauguk camek tua-i piksailkunek.",
        "translation": "They will live well if they don't [abuse] anything."
    },
    "147": {
        "startTime": 1249.61,
        "endTime": 1258.15,
        "transcript": "Utumalutek yuugarkauguk man'a inerquun taangaq atunrilkunegnegu.",
        "translation": "They will live better if they don't abuse this alcohol that's admonished against."
    },
    "148": {
        "startTime": 1259.58,
        "endTime": 1262.94,
        "transcript": "Yaa, tua-i au͡g'umek...",
        "translation": "Yes, what I just said..."
    }
};